import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AgendaItem } from '../../../core/models/event.models';

@Component({
  selector: 'app-event-agenda',
  standalone: true,
  imports: [CommonModule],
  templateUrl:'./event-agenda.component.html',


})
export class EventAgendaComponent {
  @Input({ required: true }) items!: AgendaItem[];
  track = (_: number, it: AgendaItem) => `${it.time}-${it.title}`;
}
